var render = function render(){var _vm=this,_c=_vm._self._c;return (_vm.loading)?_c('div',[(_vm.showMini)?_c('FloatCustomerServiceMini'):_c('FloatCustomerService')],1):_vm._e()
}
var staticRenderFns = []

export { render, staticRenderFns }